<template>
    <div style="width:100%; height: calc(100vh - 128px);">
        <div id="surveyCreator" />
        <Loader v-if="showLoader"></Loader>
        <MediathequeV2DialogComponent v-model="fileUrl" :openDialogMediatheque="dialogMediatheque" @close="closeDialogMediatheque" :returnUrl="true" />
    </div>
</template>

<script>
import MediathequeV2DialogComponent from '@/components/dialogs/MediathequeV2DialogComponent';
import GenericDataService from '@/services/GenericDataService';
import { SurveyCreator } from "survey-creator-knockout";
import { Serializer, slk, surveyLocalization, CustomWidgetCollection } from "survey-core";
import { editorLocalization, PropertyGridEditorCollection } from "survey-creator-core";
import "survey-creator-core/i18n/french";
import "survey-core/i18n/french";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import Loader from '@/components/Loader.vue'

// Ajout de la clé de licence
slk(process.env.VUE_APP_SURVEY);
surveyLocalization.supportedLocales = ["fr"];
surveyLocalization.defaultLocale = "fr";
const frLocale = editorLocalization.getLocale("fr");
frLocale.tabs.designer = "Éditeur de formulaire";
frLocale.tabs.preview = "Tester le formulaire";
frLocale.p.widthMode = "Largeur du formulaire";
frLocale.pe.tabs.showOnCompleted = "Formulaire terminé";
frLocale.pe.tabs.logo = "Logo dans le titre du formulaire";
frLocale.pe.cookieName = "Nom du cookie (pour empêcher de compléter 2 fois le formulaire localement)";
frLocale.ed.surveyTypeName = "Formulaire";

export default {
    name: "formModelComponent",
    props: ["model", "fieldName", "field"], 
    components: { MediathequeV2DialogComponent, Loader },
    data() {
        return {
            fileUrl: "",
            dialogMediatheque: false,
            showLoader: false,
            creator: null,
            autosave: true,
        }
    },
    mounted() {
        this.showLoader = true;
        // Sans le timeout, le composant d'affiche qu'une fois le survey chargé
        setTimeout(() => {
            this.loadScript('https://unpkg.com/jquery/dist/jquery.min.js', () => {
            this.loadStyle('https://unpkg.com/pg-calendar/dist/css/pignose.calendar.min.css', () => {
            this.loadScript('https://unpkg.com/pg-calendar@1.4.31/dist/js/pignose.calendar.full.min.js', () => {

            this.initCustomRdvQuestion();

            const options = {
                isAutoSave: true,
                showJSONEditorTab: false,
                questionTypes: ["text", "comment", "checkbox", "radiogroup", "dropdown", "rating", "tagbox", "custom-rendezvous"]
            };
            this.creator = new SurveyCreator(options);
            this.creator.locale = "fr";
            this.creator.text = typeof this.model[this.fieldName] === 'string' ? this.model[this.fieldName] : JSON.stringify(this.model[this.fieldName]);
            this.creator.saveSurveyFunc = (saveNo, callback) => {
                const jsonWithDefaults = this.creator.survey.toJSON({ storeDefaults: true });
                this.model[this.fieldName] = JSON.stringify(jsonWithDefaults);
                // this.model[this.fieldName] = this.creator.text;
                if(!this.autosave)
                    this.$emit('validateForm', true);
            };

            const vm = this;

            this.creator.onOpenFileChooser.add(function (_, options) {
                vm.dialogMediatheque = true;
            });

            // Ajout d'un champ personnalisé
            GenericDataService.getData("/entity/getSelectList2").then((response) => {
                this.creator.toolbox.addItem({
                    name: "dropdown",
                    iconName: "icon-dropdown",
                    title: this.$t("contactEntity_idTitle"),
                    json: {
                        "name": "entity",
                        "title": this.$t("contactEntity_idTitle"),
                        "type": "dropdown",
                        "placeholder": this.$t("contactEntity_idTitle"),
                        "choices": response.data.data
                    }
                });
            })

            // Ajout d'un champ personnalisé de checkboxes optin
            this.creator.toolbox.addItem({
                name: "checkbox_optin",
                iconName: "icon-checkbox",
                title: this.$t("checkboxes_optinTitle"),
                json: {
                    "type": "checkbox",
                    "name": "consents",
                    "title": this.$t("checkboxes_optinTitle"),
                    "choices": [
                        { "type": "email", "value": "email", "text": this.$t("checkboxes_optinEmail") },
                        { "type": "mobile_message", "value": "mobile_message", "text": this.$t("checkboxes_optinMobileMessage") },
                        { "type": "phone", "value": "phone", "text": this.$t("checkboxes_optinPhone") },
                        { "type": "mailing", "value": "mailing", "text": this.$t("checkboxes_optinMailing") }
                    ]
                }
            });

            this.creator.render("surveyCreator");
            this.showLoader = false;

            });
            });
            });
        }, 100);
    },
    watch: {
        fileUrl (newFileUrl) {
            this.creator.survey.logo = newFileUrl;
        }
    },
    methods: {
        closeDialogMediatheque: function(){
            this.dialogMediatheque = false;
        },
        saveSurvey: function() {
            this.autosave = false;
            this.creator.saveSurvey();
        },
        // ---- Début => Rendez-vous ----
        initCustomRdvQuestion() {
            Serializer.addClass("custom-rendezvous", [], null, "empty");

            const vm = this;

            CustomWidgetCollection.Instance.add({
                name: "custom-rendezvous",
                title: "Rendez-vous",
                iconName: "icon-matrix",
                widgetIsLoaded: () => true,
                isFit: function (question) {
                    return question.getType() === 'custom-rendezvous';
                },
                htmlTemplate: '<div class="custom-rendezvous">' +
                                    '<div style="display: flex;">' +
                                        '<div style="width: 50%;">' +
                                            '<div id="pignose-calendar"></div>' +
                                        '</div>' +
                                        '<div style="margin-left: 30px; width: calc(50% - 30px);">' +
                                            '<div style="font-size: 16px; font-weight: 600; margin-top: 5px; margin-bottom: 20px;">' +
                                                '<span id="date-selected"></span>' +
                                            '</div>' +
                                            '<div class="row" id="time-slots"></div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>',
                afterRender: function(question, el) {
                    var $calendar = $(el).find("#pignose-calendar");

                    loadCalendar();

                    function loadCalendar() {
                        vm.getCalendarOptions(question).then((options) => {
                            let pignoseOption = {
                                lang: 'fr',
                                week: 1,
                                minDate: options.dateMin,
                                maxDate: options.dateMax,
                                theme: 'blue',
                                select: function(date, context) {
                                    setDate(date[0] ? date[0].format("YYYY-MM-DD") : question.value.date_start.slice(0, 10), options);
                                }
                            };

                            if(options.daysOfWeek) {
                                let allDays = [0, 1, 2, 3, 4, 5, 6];
                                let disabledWeekdays = allDays.filter(day => !options.daysOfWeek.includes(day));
                                pignoseOption.disabledWeekdays = disabledWeekdays;
                            }

                            $calendar.pignoseCalendar(pignoseOption);
                            
                            setDate(options.dateMin, options);
                        });
                    }

                    function setDate(dateString, options) {
                        const date = new Date(dateString);
                        const days = ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"];
                        const months = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];

                        $calendar.pignoseCalendar('set', dateString);
                        $(el).find('#date-selected').html(`${days[date.getDay()]} ${date.getDate()} ${months[date.getMonth()]}`);

                        loadSlots(dateString, options);
                    }

                    function loadSlots(dateString, options) {
                        vm.getCalendarSlots(question, dateString, options).then((options) => {
                            let slotsDuration = options.slotsDuration;
                            
                            let [fromHour, fromMinute] = options.startTime.split(':').map(Number);
                            let [toHour, toMinute] = options.endTime.split(':').map(Number);

                            let startTime = new Date(dateString);
                            startTime.setHours(fromHour, fromMinute, 0, 0);
                            let endTime = new Date(dateString);
                            endTime.setHours(toHour, toMinute, 0, 0);
                            
                            let slotsContainer = $(el).find('#time-slots'); 
                            slotsContainer.empty();
                            
                            while(startTime < endTime) {
                                let slotTime = startTime.toTimeString().substring(0, 5);

                                let button = $(`<div class="col-6"><div class="btn_slot">${slotTime}</div></div>`);

                                if(options.unavailableSlots.includes(slotTime))
                                    button.addClass('disabled');

                                button.on('click', function() {
                                    if(!$(this).hasClass('disabled')) {
                                        $(el).find('#time-slots div').removeClass('selected');
                                        $(this).addClass('selected');

                                        const startDateTime = new Date(dateString + 'T' + slotTime + ':00');
                                        const endDateTime = new Date(startDateTime);
                                        endDateTime.setMinutes(endDateTime.getMinutes() + parseInt(slotsDuration));

                                        question.value = {
                                            date_start: vm.formatDateTime(startDateTime),
                                            date_end: vm.formatDateTime(endDateTime)
                                        };
                                    }
                                });
                                
                                slotsContainer.append(button);
                                startTime.setMinutes(startTime.getMinutes() + parseInt(slotsDuration));
                            }

                            const firstAvailableBtn = slotsContainer.children('div:not(.disabled)').first();
                            if(firstAvailableBtn.length) {
                                firstAvailableBtn.trigger('click');
                            }
                        });
                    }

                    const propsToWatch = ["typeOfSlots", "dateMin", "dateMax", "slotsDuration", "startTime", "endTime", "daysOfWeek", "campaingOrVendor", "campaign", "vendor"];
                    propsToWatch.forEach(prop => {
                        question.registerFunctionOnPropertyValueChanged(prop, function() {
                            vm.getCalendarOptions(question).then((options) => {
                                loadCalendar(options);
                            });
                        });
                    });
                }
            }, "customtype");

            Serializer.addProperty("custom-rendezvous", { name: "typeOfSlots", displayName: "Type de créneaux", choices: [{ value: "customised", text: "Personnalisés" }, { value: "lexxy", text: "Lexxy" }], default: "customised", category: "general", 
                enableIf: function(obj) {
                    return vm.model && vm.model.config && vm.model.config.createLead && vm.model.config.operationToCreateLead ? true : false;
                }
            });
            
            // --- Début => Créneaux personnalisés ---
            PropertyGridEditorCollection.register({ fit: (prop) => prop.type === "datepicker", getJSON: (obj, prop, options) => { return { type: "text", inputType: "date" }; } });
            Serializer.addProperty("custom-rendezvous", { name: "dateMin", displayName: "Date de début", type: "datepicker", default: this.getMonthEdge("first"), category: "Créneaux personnalisés", visibleIf: function(obj) { return obj.typeOfSlots === "customised"; } });
            Serializer.addProperty("custom-rendezvous", { name: "dateMax", displayName: "Date de fin", type: "datepicker", default: this.getMonthEdge("last"), category: "Créneaux personnalisés", visibleIf: function(obj) { return obj.typeOfSlots === "customised"; } });
            Serializer.addProperty("custom-rendezvous", { name: "slotsDuration", displayName: "Durée du créneaux", type: "dropdown", choices: this.generateDurationSlots(), default: "60", category: "Créneaux personnalisés", visibleIf: function(obj) { return obj.typeOfSlots === "customised"; } });
            Serializer.addProperty("custom-rendezvous", { name: "startTime", displayName: "De", type: "dropdown", choices: this.generateTimeSlots(), default: "08:00", category: "Créneaux personnalisés", visibleIf: function(obj) { return obj.typeOfSlots === "customised"; } });
            Serializer.addProperty("custom-rendezvous", { name: "endTime", displayName: "À", type: "dropdown", choices: this.generateTimeSlots(), default: "18:00", category: "Créneaux personnalisés", visibleIf: function(obj) { return obj.typeOfSlots === "customised"; } });
            Serializer.addProperty("custom-rendezvous", { name: "daysOfWeek", displayName: "Jours de la semaine", type: "multiplevalues", isMultiSelect: true, choices: [{ value: 1, text: "Lundi" }, { value: 2, text: "Mardi" }, { value: 3, text: "Mercredi" }, { value: 4, text: "Jeudi" }, { value: 5, text: "Vendredi" }, { value: 6, text: "Samedi" }, { value: 0, text: "Dimanche" }], default: [1, 2, 3, 4, 5, 6], category: "Créneaux personnalisés", visibleIf: function(obj) { return obj.typeOfSlots === "customised"; } });
            // --- Fin => Créneaux personnalisés ---

            // --- Début => Créneaux depuis Lexxy ---
            // Serializer.addProperty("custom-rendezvous", { name: "slotsDurationLexxy", displayName: "Durée du créneaux", type: "dropdown", choices: this.generateDurationSlots(), default: "60", category: "Créneaux depuis Lexxy", visibleIf: function(obj) { return obj.typeOfSlots === "lexxy"; } });
            Serializer.addProperty("custom-rendezvous", { name: "campaingOrVendor", displayName: "Campagne ou vendeur", choices: [{ value: "campaign", text: "Campagne" }, { value: "vendor", text: "Vendeur" }], default: "campaign", category: "Créneaux depuis Lexxy", visibleIf: function(obj) { return obj.typeOfSlots === "lexxy"; } });
            Serializer.addProperty("custom-rendezvous", { name: "campaign", displayName: "Campagne", category: "Créneaux depuis Lexxy", visibleIf: function(obj) { return obj.typeOfSlots === "lexxy" && obj.campaingOrVendor === "campaign"; },
                choices: (obj, choicesCallback) => {
                    GenericDataService.getData("/operation/_selectList?filter[status]=IN_PROGRESS").then((response) => {
                        choicesCallback(response.data.data);
                    });
                },
                default: vm.model && vm.model.config && vm.model.config.operationToCreateLead ? vm.model.config.operationToCreateLead : null,
                enableIf: function(obj) { return false; }
            });
            Serializer.addProperty("custom-rendezvous", { name: "allocationRule", displayName: "Règle d'attribution", type: "dropdown", choices: [{ value: "random", text: "Vendeur affecté / Aléatoire" }, { value: "fewestRdv", text: "Vendeur affecté / Moins de rdv" }, { value: "fewestLeads", text: "Vendeur affecté / Moins de leads" }], default: "random", category: "Créneaux depuis Lexxy", visibleIf: function(obj) { return obj.typeOfSlots === "lexxy" && obj.campaingOrVendor === "campaign"; } });
            Serializer.addProperty("custom-rendezvous", { name: "vendor", displayName: "Vendeur", category: "Créneaux depuis Lexxy", visibleIf: function(obj) { return obj.typeOfSlots === "lexxy" && obj.campaingOrVendor === "vendor"; },
                choices: (obj, choicesCallback) => {
                    if(vm.model && vm.model.config && vm.model.config.operationToCreateLead) {
                        GenericDataService.getData(`/operation/${vm.model.config.operationToCreateLead}/getTeamPlanningSelectList`).then((response) => {
                            choicesCallback(response.data.data);
                        });
                    } else {
                        choicesCallback([]);
                    }
                },
            });
            // --- Fin => Créneaux depuis Lexxy ---
        },
        generateDurationSlots() {
            const options = [];
            for(let m = 15; m <= 180; m += 15) {
                if(m < 60) {
                    options.push({ value: String(m), text: `${m}min` });
                } else {
                    const hours = Math.floor(m / 60);
                    const minutes = m % 60;
                    options.push({ value: String(m), text: minutes === 0 ? `${hours}h` : `${hours}h${minutes}` });
                }
            }
            return options;
        },
        generateTimeSlots() {
            const options = [];
            for(let h = 0; h < 24; h++) {
                for(let m = 0; m < 60; m += 15) {
                    const hour = String(h).padStart(2, '0');
                    const minute = String(m).padStart(2, '0');
                    options.push({ value: `${hour}:${minute}`, text: `${hour}h${minute}` });
                }
            }
            options.push({ value: "24:00", text: "24h00" });
            return options;
        },
        loadScript(url, callback, type = 'text/javascript') {
            if (document.querySelector(`script[src="${url}"]`)) {
                callback();
                return;
            }

            const script = document.createElement('script');
            script.type = type;
            
            document.head.appendChild(script);
            script.async = false;
            script.onload = callback;
            script.src = url;
        },
        loadStyle(url, callback) {
            if(document.querySelector(`link[href="${url}"]`)) {
                callback();
                return;
            }

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = url;
            link.onload = callback;
            document.head.appendChild(link);
        },
        getMonthEdge(which = "first") {
            const now = new Date();
            const y = now.getFullYear(), m = now.getMonth();

            let d = (which === "first") ? new Date(y, m, 1) : new Date(y, m + 1, 0);

            if (d.getDay() === 0) d.setDate(d.getDate() + (which === "first" ? 1 : -1));

            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const dd = String(d.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
        },
        async getCalendarOptions(question) {
            let options = {
                dateMin: question.dateMin,
                dateMax: question.dateMax,
                slotsDuration: question.slotsDuration,
                daysOfWeek: question.daysOfWeek,
            };

            if(question.typeOfSlots === "lexxy" && question.campaign) {
                return await GenericDataService.postData(`/ns/operation/getInfosForForm?id=${question.campaign}`).then((response) => {
                    options.dateMin = response.data.data.dateMin;
                    options.dateMax = response.data.data.dateMax;
                    options.slotsDuration = response.data.data.slotsDuration;
                    options.daysOfWeek = response.data.data.daysOfWeek;
                    return options;
                });
            } else 
                return options;
        },
        async getCalendarSlots(question, dateString, options) {
            options.startTime = question.startTime;
            options.endTime = question.endTime;
            options.unavailableSlots = [];

            if(question.typeOfSlots === "lexxy" && question.campaingOrVendor === "campaign" && question.campaign) {
                return await GenericDataService.postData(`/ns/operation/getSlotsForForm?id=${question.campaign}`, { date: dateString }).then((response) => {
                    if(response.data.data.length > 0) {
                        options.startTime = response.data.data[0].value;
                        options.endTime = response.data.data[response.data.data.length - 1].value;
                        options.unavailableSlots = response.data.data.filter(slot => !slot.available).map(slot => slot.value);
                    }
                    return options;
                });
            } else if(question.typeOfSlots === "lexxy" && question.campaingOrVendor === "vendor" && question.campaign && question.vendor) {
                return await GenericDataService.postData(`/ns/operation/getSlotsForForm?id=${question.campaign}`, { date: dateString, user_id: [question.vendor] }).then((response) => {
                    if(response.data.data.length > 0) {
                        options.startTime = response.data.data[0].value;
                        options.endTime = response.data.data[response.data.data.length - 1].value;
                        options.unavailableSlots = response.data.data.filter(slot => !slot.available).map(slot => slot.value);
                    }
                    return options;
                });
            } else 
                return options;
        },
        formatDateTime(dt) {
            const pad = n => String(n).padStart(2, '0');
            return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())} ${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;
        },
        // ---- Fin => Rendez-vous ----
    }
}

// Ajout des propriétés personnalisées
Serializer.addProperty("question", { name: "class", displayName: "Classes", type: "string", category: "general" });
Serializer.addProperty("question", { name: "data-attributes", displayName: "Attributs personnalisés", type: "itemvalues", category: "general" });
</script>

<style lang="scss">
    #surveyCreator {
        height: 100%;
        width: 100%;

        --primary: #000000;
        --primary-foreground: #ffffff;

        --sjs-primary-backcolor: #000000;
        --sjs-primary-backcolor-dark: rgba(-15, -15, -15, 1);
        --sjs-primary-backcolor-light: rgba(0, 0, 0, 0.1);
        --sjs-primary-forecolor: rgba(255, 255, 255, 1);
        --sjs-primary-forecolor-light: rgba(255, 255, 255, 0.25);

        .custom-rendezvous {
            .pignose-calendar.pignose-calendar-blue {
                margin: 0;
                width: 100%;
                font-size: 12px;
                box-shadow: none;
                border: 1px solid #424A61;

                .pignose-calendar-top {
                    padding: 1em;
                    background-color: #424A61;

                    .pignose-calendar-top-date {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-transform: none;
                    }

                    .pignose-calendar-top-month {
                        margin-bottom: 0;
                        margin-right: .4em;
                    }
                }

                .pignose-calendar-header {
                    margin-top: 0;
                    background-color: #F3F3FE;

                    .pignose-calendar-week.pignose-calendar-week-sat, .pignose-calendar-week.pignose-calendar-week-sun {
                        color: #5c6270;
                    }
                }

                .pignose-calendar-body {
                    .pignose-calendar-row {
                        .pignose-calendar-unit {
                            height: 2.8em;

                            &.pignose-calendar-unit-disabled a {
                                background-color: transparent;
                            }

                            &.pignose-calendar-unit.pignose-calendar-unit-sat a, &.pignose-calendar-unit.pignose-calendar-unit-sun a {
                                color: #5c6270;
                            }
                        }

                        .pignose-calendar-unit.pignose-calendar-unit-active a {
                            background-color: #424A61;
                            color: #ffffff !important;
                        }
                    }
                }
            }

            .row {
                display: flex;
                flex-wrap: wrap !important;
                margin-top: calc(0.25rem * -1);
                margin-right: calc(0.5rem * -.5);
                margin-left: calc(0.5rem * -.5);
            }
            .col-6 {
                flex: 0 0 auto;
                width: 46%;
                padding: 0;
            }
            .row>* {
                max-width: 100%;
                padding-right: calc(0.5rem * .5);
                padding-left: calc(0.5rem * .5);
                margin-top: 0.25rem;
            }
            .btn_slot {
                border: 1px solid #424A61;
                color: #424A61;
                background-color: transparent;
                border-radius: 4px;
                text-transform: none;
                padding: 10px 0px;
                width: 100%;
                margin-bottom: 2px;
                font-size: 14px;
                line-height: 15px;
                text-align: center;
                cursor: pointer;
            }
            .selected>.btn_slot {
                background-color: #424A61;
                color: #ffffff;
            }
            .disabled>.btn_slot {
                opacity: 0.3;
                cursor: initial;
            }
        }
    }
</style>